export type SuggestionHighlight = {
  before: string;
  match: string;
  after: string;
};

const REGEXP_SPECIAL_CHARACTERS = /[.*+?^${}()|[\]\\]/g;

function escapeRegExp(text: string): string {
  return text.replace(REGEXP_SPECIAL_CHARACTERS, String.raw`\$&`);
}

/**
 * Splits a suggestion around the first case-insensitive occurrence of what the
 * donor typed. With no match, the whole text is `before`, so callers always
 * get the same three parts.
 */
export function splitAtMatch(
  text: string,
  search: string,
): SuggestionHighlight {
  const found = search
    ? new RegExp(escapeRegExp(search), "i").exec(text)
    : null;

  if (!found) {
    return { before: text, match: "", after: "" };
  }

  const matchEnd = found.index + found[0].length;

  return {
    before: text.slice(0, found.index),
    match: found[0],
    after: text.slice(matchEnd),
  };
}
